<template>
    <v-container fluid grid-list-lg>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Gestión de clientes</h1>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-card>
                    <v-toolbar flat>
                        <v-spacer></v-spacer>
                        <v-tooltip top>
                            <v-btn flat small icon color="green" dark @click.native="clienteAddModal = true" slot="activator">
                                <v-icon>add</v-icon>
                            </v-btn>
                            <span>Agregar cliente</span>
                        </v-tooltip>
                        <v-tooltip top class="text-xs-center">
                            <v-btn flat small icon color="purple" dark @click.native="vincular()" slot="activator">
                                <v-icon>sync</v-icon>
                            </v-btn>
                            <span>Vincular microsiga</span>
                        </v-tooltip>
                    </v-toolbar>
                    <v-data-table
                            :headers="headers"
                            :items="items"
                            :pagination.sync="pag"
                            :total-items="totalItems"
                            :loading="loading"
                            :rows-per-page-items="rows"
                            rows-per-page-text="Filas por pagina"
                            no-data-text="No hay datos"
                            disable-initial-sort
                            item-key="id"
                    >
                        <template slot="items" slot-scope="props">
                            <td class="text-xs-left">{{ props.item.rzon_soc }}</td>
                            <td class="text-xs-center">{{ props.item.cuit | cuit }}</td>
                            <td class="text-xs-right">{{ props.item.tel }}</td>
                            <td class="text-xs-right">{{ props.item.dir }}</td>
                            <td class="text-xs-right">{{ props.item.email }}</td>
                            <td class="text-xs-center">
                                <v-tooltip top>
                                    <v-avatar size="20" slot="activator">
                                        <img :src="'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/flags/1x1/'+ props.item.pais.alfa2.toLowerCase() +'.svg'"/>
                                    </v-avatar>
                                    <span>{{ props.item.pais.nombre }}</span>
                                </v-tooltip>
                            </td>
                            <td class="text-xs-right">{{ (props.item.provincia)? props.item.provincia.desig : '' }}</td>
                            <td class="text-xs-right">{{ props.item.micro_id_1 }}</td>
                            <td class="text-xs-right">{{ props.item.micro_id_2 }}</td>
                            <td class="text-xs-right">{{ props.item.micro_id_3 }}</td>
                            <td class="text-xs-center">
                                <v-icon small color="blue" @click="itemEdit(props.item.id)">edit</v-icon>
                                <v-icon small @click="itemDelete(props.item)" color="red">delete</v-icon>
                            </td>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <modal-cliente v-model="clienteAddModal" :oper="oper" :cliente="clienteIdModal"></modal-cliente>
    </v-container>
</template>

<script>
    import filterCuit from '../../filters/cuit'
    import mixinCliente from '../../mixins/cliente'
    import modalCliente from '../../components/ModalCliente';

    export default {
        name: "list",
        mixins: [mixinCliente],
        filters: {cuit: filterCuit},
        components: {modalCliente},
        data() {
            return {
                loading: false,
                headers: [
                    {text: 'Razon social', value: 'rzon_soc', align: 'center'},
                    {text: 'CUIT', value: 'cuit', align: 'center',width:'200px'},
                    {text: 'Teléfono', value: 'tel', align: 'center'},
                    {text: 'Dirección', value: 'dir', align: 'center'},
                    {text: 'Email', value: 'email', align: 'center'},
                    {text: 'Pais', value: 'pais_id', align: 'center'},
                    {text: 'Provincia', value: 'provincia_id', align: 'center'},
                    {text: 'Id Friolatina', value: 'micro_id_1', align: 'center'},
                    {text: 'Id Bervill', value: 'micro_id_2', align: 'center'},
                    {text: 'Id Acerolatina', value: 'micro_id_3', align: 'center'},
                    {text: 'Oper', value: '', align: 'center'},
                ],
                items: [],
                search: '',
                pag: {},
                rows: [10, 20, 30, {text: 'Todo', value: -1}],
                totalItems: 0,
                ///////////////
                clienteAddModal: false,
                clienteIdModal: '',
                oper: 'add'
            }
        },
        watch: {
            pag: {
                handler() {
                    this.getTableData();
                },
                deep: true
            }
        },
        mounted() {
        },
        methods: {
            vincular() {
                this.loading = true;
                this.clienteVincular(r => {
                    this.getTableData();
                    this.loading = false;
                }, err => {
                    this.loading = false;
                })
            },
            getTableData() {
                this.loading = true;
                this.clienteIndex(this.pag, r => {
                    this.items = r.data;
                    this.totalItems = r.total;
                    this.loading = false;
                }, err => {
                    console.log(err);
                    this.loading = false;
                })
            },
            itemAdd() {
                this.oper = 'add';
                this.clienteAddModal = true;
            },
            itemDelete() {

            },
            itemEdit(id) {
                this.oper = 'edit';
                this.clienteIdModal = id;
                this.clienteAddModal = true;
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/archivo/clientes.vue